import { Expose } from "class-transformer";

export class CreatePaymentMethodDto {
  @Expose()
  name: string;

  @Expose()
  requiresAccountingReconciliation: boolean;

  @Expose()
  canBeIncludedInExpenseSheet: boolean;

  @Expose()
  isDefaultForPurchaseOrders?: boolean;
}
